export default __webpack_public_path__ + "static/media/clouds.325e47bc.jpeg";